// extracted by mini-css-extract-plugin
export var menuItem = "B_t8 d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "B_t9 d_Z d_bz d_bP";
export var menuMainLink = "B_vb d_f0 d_dB";
export var menuLink = "B_vc d_f0 d_dB";
export var icon = "B_p9 d_bC d_bP";
export var divider = "B_vd d_bC d_bP";
export var sublinks = "B_vf";
export var link = "B_mC";
export var Link = "B_sb t_sb t_rD t_rY";